module.exports = require("lodash/isNumber");